import { selectedFlowIdState } from '@/state/flow.state';
import type { AppFlowObjectKnown } from '@/util/AppFlowObjectKnown';
import { AppFlowDao } from '@rock/db-admin';
import type { AppFlowObject, AppFlowParams, EquipmentTypeId, SpaceId } from '@rock/types';
import { shallowEqual } from '@rock/util';
import { atom } from 'jotai/index';
import { atomFamily, loadable } from 'jotai/utils';

const appFlowDao = new AppFlowDao();

export const editingFlowState = atom<AppFlowObject | undefined>(undefined);
export const editFlowOpenState = atom(false);

const draftFlowsBaseState = atomFamily((spaceId: SpaceId) => appFlowDao.draftFlowsAtom(spaceId), shallowEqual);

export const draftFlowsState = atomFamily(
    (params: AppFlowParams) =>
        atom(async (get) => {
            const { spaceId, equipmentTypeId } = params;
            const flows = await get(draftFlowsBaseState(spaceId));
            return flows.filter((f) =>
                equipmentTypeId ? f.equipmentTypeId === equipmentTypeId : !f.equipmentTypeId,
            ) as AppFlowObjectKnown[];
        }),
    shallowEqual,
);

export const selectedDraftFlowState = atomFamily((params: AppFlowParams) =>
    loadable(
        atom(async (get) => {
            const selectedFlowId = get(selectedFlowIdState(params));
            const draftFlows = await get(draftFlowsState(params));
            return draftFlows.find((f) => f.id === selectedFlowId) as AppFlowObjectKnown;
        }),
    ),
);

export const flowsByTypeIdState = atomFamily((spaceId: SpaceId) =>
    atom(async (get) => {
        const flows = await get(draftFlowsBaseState(spaceId));
        return flows.reduce((map, flow) => {
            if (flow.equipmentTypeId) {
                map.set(flow.equipmentTypeId, flow.name);
            }
            return map;
        }, new Map<EquipmentTypeId, string>());
    }),
);
